import React, { useState, useRef, useEffect } from "react";
import PropTypes from "prop-types";

const SelectOption = ({ value, onChange, options, ariaLabel }) => {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  const [menuStyle, setMenuStyle] = useState({});

  useEffect(() => {
    const onDocClick = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener("mousedown", onDocClick);
    return () => document.removeEventListener("mousedown", onDocClick);
  }, []);

  useEffect(() => {
    if (!open) {
      setMenuStyle({});
      return;
    }

    const el = ref.current;
    if (!el) return;

    const updatePosition = () => {
      const rect = el.getBoundingClientRect();
      setMenuStyle({
        position: "absolute",
        width: `${Math.floor(rect.width)}px`,
        zIndex: 10000,
        left: 0,
      });
    };

    updatePosition();
    window.addEventListener("resize", updatePosition);
    window.addEventListener("scroll", updatePosition, true);
    return () => {
      window.removeEventListener("resize", updatePosition);
      window.removeEventListener("scroll", updatePosition, true);
    };
  }, [open]);

  const selected = options.find((o) => o.value === value);

  return (
    <div className="select-option" ref={ref} style={{ position: "relative" }}>
      <button
        type="button"
        className={`lang-toggle ${open ? "open" : ""}`}
        aria-haspopup="menu"
        aria-expanded={open}
        onClick={() => setOpen((s) => !s)}
      >
        <span className="lang-label">{selected ? selected.label : ""}</span>
        <svg
          className="caret-icon"
          xmlns="http://www.w3.org/2000/svg"
          width="12"
          height="12"
          viewBox="0 0 24 24"
          fill="none"
          aria-hidden="true"
        >
          <path
            d="M6 9l6 6 6-6"
            stroke="#374151"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </button>

      {open && (
        <ul
          className="lang-menu"
          role="menu"
          aria-label={ariaLabel}
          style={menuStyle}
        >
          {options.map((opt) => (
            <li
              key={opt.value}
              role="menuitem"
              className={opt.value === value ? "selected" : ""}
              onClick={() => {
                onChange(opt.value);
                setOpen(false);
              }}
            >
              <span>{opt.label}</span>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

SelectOption.propTypes = {
  value: PropTypes.any,
  onChange: PropTypes.func.isRequired,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.any.isRequired,
      label: PropTypes.node.isRequired,
    })
  ).isRequired,
  ariaLabel: PropTypes.string,
};

SelectOption.defaultProps = {
  ariaLabel: "select",
};

export default SelectOption;
